import type { IconData } from '@stacksjs/iconify-core'

export const drinkFoodMeat: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 12a6 6 0 1 0-5.124-2.876l-1.462 1.462A2 2 0 1 0 2 14a2 2 0 1 0 3.414-1.414l1.462-1.462c.91.556 1.98.876 3.124.876\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default drinkFoodMeat
